import React from 'react';
import { useSelector } from 'react-redux';
import SearchBar from '~/components/SearchBar';
import { EAA_Item, EAA_ItemContainer, EAA_Row, EAA_TitleText, EAA_Input, EAA_Add_Btn, EAA_Select, EAA_Memo, EAA_Area } from '~/components/EditAndAddItem';

const emptyBody = {
  note: '',
  storage_local: '',
  storage_local_other: '',
  storage_num: '',
};

const App = props => {
  const { titleWidth, disabled, checkSubChange, changeData, data } = props;
  const PPPlanSecondList = useSelector(state => state.data.PPPlanSecondList);

  const ary = data.sub2 || [];
  if (ary.length === 0)ary.push({ ...emptyBody });

  const saveSub = dataAry => {
    changeData({ label: 'sub2', data: dataAry });
  };

  const addRow = () => {
    ary.push({ ...emptyBody });
    saveSub(ary);
  };

  const delRow = n => {
    ary.splice(n, 1);
    saveSub(ary);
  };

  const renderAry = [];

  for (let i = 0; i < ary.length; i++) {
    const isFirst = i === 0;
    renderAry.push(
      <EAA_Area
        key={`Page_ProjectProgress_sub2_${i}`}
        backgroundColor='white'
        titleItem={<EAA_Add_Btn disabled={disabled} del={!isFirst} onClick={(!isFirst) ? () => delRow(i) : () => addRow()} />}
      >
        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='貯放地點' bol />
              <EAA_Select displayBorder disabled={disabled} list={PPPlanSecondList} value={ary[i].storage_local} onChange={data => { ary[i].storage_local = data; saveSub(ary); }} />
            </EAA_ItemContainer>
            {/* {errorAry[0] && <ErrorText text='帳號需為 1 ~ 100 英數字。' />} */}
          </EAA_Item>
          <EAA_Item>
            <EAA_ItemContainer>
              {ary[i].storage_local === '船上/其他' && <EAA_Input displayBorder disabled={disabled} hint='自填' value={ary[i].storage_local_other} onChange={data => { ary[i].storage_local_other = data; saveSub(ary); }} />}
            </EAA_ItemContainer>
            {/* {errorAry[0] && <ErrorText text='帳號需為 1 ~ 100 英數字。' />} */}
          </EAA_Item>
        </EAA_Row>
        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='說明' bol />
              <EAA_Memo displayBorder disabled={disabled} value={ary[i].note} onChange={data => { ary[i].note = data; saveSub(ary); }} />
            </EAA_ItemContainer>
            {/* {errorAry[0] && <ErrorText text='帳號需為 1 ~ 100 英數字。' />} */}
          </EAA_Item>
        </EAA_Row>
        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} text='數量' bol />
              <EAA_Input displayBorder disabled={disabled} type='number' hint='請填寫數字' value={ary[i].storage_num} onChange={data => { ary[i].storage_num = data; saveSub(ary); }} />
            </EAA_ItemContainer>
            {/* {errorAry[0] && <ErrorText text='帳號需為 1 ~ 100 英數字。' />} */}
          </EAA_Item>
          <EAA_Item />
        </EAA_Row>
      </EAA_Area>,
    );
  }

  return (
    <SearchBar style={{ marginTop: 8 }} text='貯放資訊'>
      {renderAry}
    </SearchBar>
  );
};

export default App;
